import { PersonApiGetDto } from '../../shared'
import * as fromActions from './person.actions'

export interface State {
  personHierarchy: PersonApiGetDto[]
}

export const initialState: State = {
  personHierarchy: [],
}

export const reducer = (state = initialState, action: fromActions.default): State => {
  switch (action.type) {
    case fromActions.GET_HIERARCHY_ID_TO_ROOT_SUCCESS:
    case fromActions.GET_HIERARCHY_ID_TO_CURRENT_SUCCESS: {
      const personHierarchy = action.payload

      return { ...state, personHierarchy }
    }

    default:
      return state
  }
}

export const getUserHierarchy = (state: State) => state.personHierarchy



// WEBPACK FOOTER //
// ./src/app/shared/store/person.reducer.ts